<template>
    <div v-if="exibirModalDesentranharDocumento" class="modal-overlay">
        <div class="modal-fullscreen">
            <div class="stepper-container">
                <div class="stepper-header">
                    <div id="acaoVoltar" class="back-button-container" @click="tratarEventoVoltar">
                        <div class="back-button">
                            <div class="back-button-content">
                                <span class="back-button-text">
                                    <i class="mdi mdi-arrow-left"></i>
                                    Voltar
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="step-divider"></div>

                    <div
                        :key="`${passos[0].numero}-header`"
                        class="step-button"
                        :class="{
                            'step-complete': passos[0].completo,
                            'step-disabled': passos[0].desabilitado,
                            'step-active': passoAtual && passoAtual.numero === passos[0].numero
                        }"
                        @click="tratarEventoPassoSelecionado(passos[0])"
                    >
                        <div class="step-indicator">
                            <span v-if="passos[0].completo" class="step-check">✓</span>
                            <span v-else class="step-number">{{ passos[0].numero }}</span>
                        </div>
                        <span class="step-title">{{ passos[0].titulo }}</span>
                    </div>

                    <div class="step-divider"></div>

                    <div
                        :key="`${passos[1].numero}-header`"
                        class="step-button"
                        :class="{
                            'step-complete': passos[1].completo,
                            'step-disabled': passos[1].desabilitado,
                            'step-active': passoAtual && passoAtual.numero === passos[1].numero
                        }"
                        @click="tratarEventoPassoSelecionado(passos[1])"
                    >
                        <div class="step-indicator">
                            <span v-if="passos[1].completo" class="step-check">✓</span>
                            <span v-else class="step-number">{{ passos[1].numero }}</span>
                        </div>
                        <span class="step-title">{{ passos[1].titulo }}</span>
                    </div>
                </div>

                <div class="stepper-content">
                    <div class="content-card">
                        <router-view
                            v-if="urlAcessoDocumento"
                            :url-acesso-documento="urlAcessoDocumento"
                            @voltar="tratarEventoVoltar"
                        ></router-view>
                        <div v-else class="loading-container">
                            <div class="loading-spinner"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de confirmação para concluir edição -->
        <ModalConfirmacaoTermoDesentranhamento
            :exibir="exibirModalConfirmacao"
            :processando="processandoSincronizacao"
            @cancelar="fecharModalConfirmacao"
            @confirmar="confirmarConcluirEdicao"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {actionTypes} from '@/core/constants'
import alertMixin from '@/views/mixins/alert'
import ModalConfirmacaoTermoDesentranhamento from './components/ModalConfirmacaoTermoDesentranhamento.vue'

export default {
    name: 'termo-desentranhamento',
    components: {
        ModalConfirmacaoTermoDesentranhamento
    },
    mixins: [alertMixin],
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.rotaAnterior = from.name ? from.name : 'documentosCompraDireta'
        })
    },
    data() {
        return {
            exibirModalDesentranharDocumento: true,
            exibirModalConfirmacao: false,
            processandoSincronizacao: false,
            idTermo: null,
            passoAtual: {},
            passos: [
                {
                    titulo: 'Redigir',
                    rota: 'termoDesentranhamentoRedigir',
                    desabilitado: false,
                    completo: false,
                    numero: 1,
                },
                {
                    titulo: 'Concluir Edição',
                    rota: 'termoDesentranhamentoConcluir',
                    desabilitado: true,
                    completo: false,
                    numero: 2,
                },
            ],
            termoDesentranhamento: {},
            urlAcessoDocumento: null,
        }
    },
    computed: {
        ...mapState({
            compraDireta: (state) => state.compraDireta.dados,
        }),
        passoRedigirTermoEstaCompleto() {
            return this.termoDesentranhamento && this.termoDesentranhamento.documentoVirtualizadoId
        },
    },
    async created() {
        try {
            this.setIdTermo()
            await this.buscarTermoDesentranhamento()
            this.tratarPassoAtual()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
            await this.$router.push({ name: 'documentosCompraDireta', params: { id: this.$route.params.id } })
        }
    },
    destroyed() {
        sessionStorage.removeItem('jwt')
        sessionStorage.removeItem('redirect')
    },
    methods: {
        async buscarTermoDesentranhamento() {
            try {
                const documento = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DOCUMENTO_EDITOR_TEXTO_POR_ID, this.idTermo)
                this.termoDesentranhamento = {
                    id: documento.id,
                    idExterno: documento.idExterno,
                    idExternoEstatico: documento.idExternoEstatico,
                    titulo: 'Termo de Desentranhamento',
                    tipoDocumento: documento.tipoDocumento,
                    compraDiretaId: documento.compraDiretaId,
                    documentoReferenciaVirtualizadoId: documento.documentoReferenciaVirtualizadoId,
                    situacao: 'RASCUNHO',
                    urlEdicao: documento.urlEdicao,
                    urlVisualizacao: documento.urlVisualizacao,
                    dataCadastro: documento.dataCadastro,
                    dataAlteracao: documento.dataAlteracao,
                    usuarioCadastro: documento.usuarioCadastro,
                    usuarioAlteracao: documento.usuarioAlteracao,
                    nomeUsuarioLogado: documento.nomeUsuarioLogado
                }
                
                this.urlAcessoDocumento = this.termoDesentranhamento.urlEdicao ? this.termoDesentranhamento.urlEdicao : this.termoDesentranhamento.urlVisualizacao
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            }
        },
        setIdTermo() {
            this.idTermo = this.$route.params.idTermo
        },
        async tratarEventoPassoSelecionado(passo) {
            if (passo.desabilitado) {
                return
            }
            
            if (passo.numero === 2) {
                this.abrirModalConfirmacao()
                return
            }
            
            if (passo.rota === this.$route.name) {
                return
            }
            
            try {
                await this.$router.replace({ name: passo.rota })
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') {
                    throw error
                }
            }
        },
        tratarEventoVoltar() {
            this.$router.push({ 
                name: 'documentosCompraDireta', 
                params: { 
                    id: this.termoDesentranhamento.compraDiretaId || this.$route.params.id 
                } 
            })
        },
        tratarPassoAtual() {
            if (!this.passoRedigirTermoEstaCompleto) {
                this.passos[0].desabilitado = false
                this.passos[1].desabilitado = false
                this.setPassoAtual(this.passos[0])
                this.redirecionarParaPasso1()
                return
            }
            
            this.passos[0].completo = true
            this.passos[1].desabilitado = false
            this.setPassoAtual(this.passos[1])
        },
        setPassoAtual(passo) {
            this.passoAtual = passo
        },
        async redirecionarParaPasso1() {
            if (this.passos[0].rota === this.$route.name) {
                return
            }
            try {
                await this.$router.replace({ name: this.passos[0].rota })
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') {
                    throw error
                }
            }
        },
        async sincronizarDocumento() {
            try {
                this.processandoSincronizacao = true
                
                const response = await this.$store.dispatch(actionTypes.COMPRADOR.SINCRONIZAR_DOCUMENTO_EDITOR_TEXTO, {idDocumentoEditorTexto: this.termoDesentranhamento.id})
                
                this.passos[1].completo = true
                this.mostrarNotificacaoSucesso(response.mensagem || 'Documento sincronizado com sucesso!')
                
                setTimeout(() => {
                    this.tratarEventoVoltar()
                }, 2000)
                
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            } finally {
                this.processandoSincronizacao = false
            }
        },
        abrirModalConfirmacao() {
            this.exibirModalConfirmacao = true
        },
        fecharModalConfirmacao() {
            this.exibirModalConfirmacao = false
        },
        async confirmarConcluirEdicao() {
            await this.sincronizarDocumento()
            this.fecharModalConfirmacao()
        },
    },
}
</script>

<style scoped>
/* Modal Overlay - Fullscreen */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-fullscreen {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

/* Stepper Container */
.stepper-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Stepper Header */
.stepper-header {
  height: 64px;
  min-height: 64px;
  max-height: 64px;
  background-color: #0067A5;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Back Button */
.back-button-container {
  flex: 0 0 auto;
  padding: 0;
}

.back-button {
  cursor: pointer;
  background-color: #104D75;
  color: white;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  min-width: 120px;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #0d3d5c;
}

.back-button-content {
  display: flex;
  align-items: center;
}

.back-button-text {
  font-weight: bold;
  font-size: 0.9em;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-button-text i {
  font-size: 16px;
}

/* Step Divider */
.step-divider {
  width: 1px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0 8px;
}

/* Step Button */
.step-button {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  color: white;
  font-weight: bold;
  font-size: 0.9em;
  transition: background-color 0.3s ease;
  min-height: 64px;
  gap: 12px;
}

.step-button:hover:not(.step-disabled) {
  background-color: rgba(255, 255, 255, 0.1);
}

.step-button.step-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.step-button.step-active {
  background-color: rgba(255, 255, 255, 0.2);
}

.step-indicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: white;
  color: #0067A5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  flex-shrink: 0;
}

.step-button.step-complete .step-indicator {
  background-color: #4CAF50;
  color: white;
}

.step-check {
  font-size: 14px;
  font-weight: bold;
}

.step-number {
  font-size: 12px;
  font-weight: bold;
}

.step-title {
  white-space: nowrap;
}

/* Stepper Content */
.stepper-content {
  flex: 1;
  min-height: calc(100vh - 64px);
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.content-card {
  flex: 1;
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Loading Container */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0067A5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


/* Responsive Design */
@media (max-width: 768px) {
  .stepper-header {
    flex-wrap: wrap;
    height: auto;
    min-height: 64px;
  }
  
  .back-button {
    min-width: 100px;
    padding: 0 12px;
  }
  
  .step-button {
    padding: 8px 12px;
    font-size: 0.8em;
  }
  
  .step-title {
    display: none;
  }
  
  .confirmation-modal {
    margin: 16px;
    width: calc(100% - 32px);
  }
}

@media (max-width: 480px) {
  .back-button-text {
    font-size: 0.8em;
  }
  
  .step-indicator {
    width: 20px;
    height: 20px;
    font-size: 10px;
  }
}
</style>